export const MODULE_NAME = 'axp-travel-search-flight-hotel';
export const ROOT_MODULE_NAME = 'axp-consumer-travel-root';
export const MODULE_NAME_SEARCH_REDIRECT = 'axp-travel-search-redirect';
export const MODULE_NAME_SEARCH_LOCATIONS = 'axp-travel-search-locations';
export const MODULE_NAME_SEARCH_ROOMS_TRAVELERS = 'axp-travel-search-rooms-travelers';
export const MODULE_NAME_SEARCH_DATE_PICKER = 'axp-travel-search-date-picker';
export const ACTION_PREFIX = `modules/${MODULE_NAME}`;
export const MAX_ADVANCE_BOOKING = 330;
export const MAX_NIGHTS = 28;
export const ANYTIME = 'ANYTIME';

export const BUNDLE_TYPES = {
  AIR_HOTEL: 'AIR_HOTEL',
  AIR_CAR: 'AIR_CAR',
  AIR_HOTEL_CAR: 'AIR_HOTEL_CAR',
};
